import { ApplicationStage } from '../../../api/types';
import ListPageInner from '../../shared/ApplicationListPage/ListPageInner';

const ReservationListPage = () => {
    const stage = ApplicationStage.Reservation;
    const namespace = 'reservationList';

    return <ListPageInner namespace={namespace} stage={stage} />;
};

export default ReservationListPage;
